import { authProvider } from "../context/authProvider";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { TableAdministracionNotificaciones } from "../components/TableAdministracionNotificaciones";
import "../theme/ReporteCierreDia.css";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPageNotificaciones = () => {
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div>
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>
              <div className="container-notificaciones">
                <TableAdministracionNotificaciones />
              </div>
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
